<template>
  <HistoryEventContainer />
</template>

<script>
import HistoryEventContainer from '@/modules/history/components/HistoryEventContainer'

export default {
  name: 'HistoryEvent',

  components: {
    HistoryEventContainer
  },

  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.set('history/isHistoryEvent', true)
    })
  },

  beforeDestroy() {
    this.$store.set('history/isHistoryEvent', false)
  }
}
</script>
